<template>
  <div class="flex flex-col mb-8"> <!-- host -->
    <div class="flex mb-4">
      <div class="w-full flex flex-col mr-4">
        <label class="mb-1 text-sm">Hosting Agent</label>
        <input class="w-full border border-grey-dark rounded p-3 text-sm" v-model="host.name" placeholder="Your name" />
      </div>
      <div class="w-full flex flex-col">
        <label class="mb-1 text-sm">Phone Number</label>
        <input class="w-full border border-grey-dark rounded p-3 text-sm" v-model="host.phone" placeholder="Your phone number" />
      </div>
    </div>
    <div class="flex flex-col">
      <label class="mb-1 text-sm">Email Address</label>
      <input class="border border-grey-dark rounded p-3 text-sm" v-model="host.email" placeholder="Your email address" />
    </div>
  </div> <!-- host end -->
</template>

<script>
export default {
  name: 'Host',

  props: ['value'],

  computed: {
    host: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
